import { Race, Input } from "../shared/physics";

/** Title-screen autopilot: keeps the road centre, but overtakes: it picks a free lane when a car blocks it and uses the jet on clear straights. */
export class DemoDriver {
  private lane = 128;
  private hold = 0; // frames before another lane change is allowed
  input(race: Race): Input {
    const me = race.cars[0];
    const others = race.cars.slice(1);
    const blocked = (lane: number, ahead = 2600, behind = 350) =>
      others.some((o) => {
        const dz = o.pos - me.pos;
        return dz > -behind && dz < ahead && Math.abs(o.lat - lane) < 26;
      });
    if (this.hold > 0) this.hold--;
    // current lane blocked by a slower car ahead → look for a free one (the nearest to where we are)
    const near = others.some((o) => {
      const dz = o.pos - me.pos;
      return dz > -250 && dz < 1800 && Math.abs(o.lat - me.lat) < 28;
    });
    if (this.hold === 0 && (blocked(this.lane, 1800) || near)) {
      const cands = [128, 96, 160, 80, 176].sort((a, b) => Math.abs(a - me.lat) - Math.abs(b - me.lat));
      const free = cands.find((l) => l !== this.lane && !blocked(l, 2800, 450));
      if (free !== undefined) {
        this.lane = free;
        this.hold = 70;
      }
    } else if (this.hold === 0 && this.lane !== 128 && !blocked(128, 2200, 500)) {
      this.lane = 128; // back to the racing line once it is clear
      this.hold = 90;
    }
    const clear = !near && !blocked(me.lat, 2400, 0);
    return {
      accel: true,
      brake: false,
      jet: clear && me.fuel > 12 && me.speed > 150 && Math.abs(me.lat - this.lane) < 6,
      left: me.lat > this.lane + 3,
      right: me.lat < this.lane - 3,
    };
  }
}
